import {FjdButton, FjdCard, FjdHeading} from "@efast/fjd-react-components";
import React from "react";
import CertificateConfirmationModal from "./app/Certificate/CertificateConfirmationModal";
import Layout from "./app/Layout/Layout";
import QRScanModal from "./app/QRScan/QRScanModal";
import {Certificate, ErrorTypes} from "./model/Certificate";
import txt from "./content.json";
import getDataFromQRCode from "./util/getDataFromQRCode";
import DecryptionService from "./util/DecryptionService";
import CollapsableCard from "./app/Components/CollapsableCard/CollapsableCard";

function App() {
    const [showCertificateValidated, setShowCertificateValidated] = React.useState(false);
    const [showScanner, setShowScanner] = React.useState(false);
    const [certificate, setCertificate] = React.useState<Certificate>();
    const [loadingCertificate, setLoadingCertificate] = React.useState<boolean>();
    const [errorType, setErrorType] = React.useState<ErrorTypes>();
    const [isTest, setIsTest] = React.useState(false);
    // validate certificate in API
    const checkCertificate = async (data: string) => {
        let {rawData, encryptedSignature, isTest} = getDataFromQRCode(data);

        if (!encryptedSignature) {
            setErrorType(ErrorTypes.qrcode);
            return {valid: false};
        }

        try {
            setIsTest(isTest)
            const Decrypt: DecryptionService = new DecryptionService(null);
            const verificationResult: boolean = await Decrypt.verifySignature(
                encryptedSignature,
                rawData,
                isTest
            );
            return {valid: verificationResult};

        } catch (error) {
            setErrorType(ErrorTypes.cert);
        }
        return {valid: false};
    };

    const handleClick = async () => {
        setShowScanner(true);
    };

    const handleScanError = (err: any) => {
        setErrorType(ErrorTypes.qrcode);
    };

    const verifyData = async (data: string) => {
        let {firstName, lastName, submittedOn, authority} = getDataFromQRCode(data);

        const responseData = await checkCertificate(data);

        setCertificate({
            valid: responseData.valid,
            user: {
                firstName: firstName || "",
                lastName: lastName || ""
            },
            submittedOn: submittedOn,
            authority: authority
        });

        if (!responseData.valid) {
            setLoadingCertificate(false);
        }
    };

    const handleScan = (data: string | null) => {
        if (data) {
            setShowScanner(false);
            setLoadingCertificate(true);
            verifyData(data).then(r => setShowCertificateValidated(true));

            setLoadingCertificate(false);
        }
    };

    const handleScanClick = () => {
        setShowCertificateValidated(false);
        setShowScanner(true);
    };

    return (
        <Layout>
            <FjdHeading level={1} text={txt.app.title}></FjdHeading>
            <FjdCard
                padding="xl"
                minHeight={200}
                solid={true}
                footer={
                    <FjdButton iconLeft="qr" label={txt.app.btnLabel} onClick={handleClick}></FjdButton>
                }
            >
                <FjdHeading level={2} text={txt.app.descriptionTitle}></FjdHeading>
                <p>{txt.app.description.split('\n').map(l => <>{l}<br/></>)}</p>
            </FjdCard>
            <CollapsableCard header="Anleitung"
                             children={<span>{txt.app.instructions.split('\n').map(l => <>{l}<br/></>)}</span>}/>
            <QRScanModal
                onError={handleScanError}
                open={showScanner}
                onScan={handleScan}
                onClose={() => setShowScanner(false)}
            ></QRScanModal>
            <CertificateConfirmationModal
                loading={loadingCertificate}
                errorType={errorType}
                onScanClick={handleScanClick}
                certificate={certificate}
                open={showCertificateValidated}
                onClose={() => setShowCertificateValidated(false)}
                isTest={isTest}
            ></CertificateConfirmationModal>
        </Layout>
    );
}

export default App;
